import { IdentityOptions } from '../types/internal-types';

export class OptionsService {
  constructor(public readonly options: IdentityOptions) {}
}
